'use client';

import { useTabNavStyles } from '@/shared/components/ui/tab-nav/tab-nav.styles';
import { Tab, TabGroup, TabList, TabPanel, TabPanels } from '@headlessui/react';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { FC, ReactNode } from 'react';
import { twJoin } from 'tailwind-merge';

type TabNavProps = {
  tabs: {
    name: string;
    panel: ReactNode;
    disabled?: boolean;
  }[];
};

export const TabNav: FC<TabNavProps> = ({ tabs }) => {
  const { tabStyle } = useTabNavStyles();
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  // Obtém o índice da aba a partir da query string
  const tabIndex = Number(searchParams.get('tab')) || 1;
  const activeTab = Math.min(Math.max(tabIndex, 1), tabs.length) - 1;

  const updateTabInURL = (index: number) => {
    const params = new URLSearchParams(searchParams.toString());
    params.set('tab', String(index + 1));
    router.replace(`${pathname}?${params.toString()}`, { scroll: false });
  };

  return (
    <TabGroup
      selectedIndex={activeTab}
      onChange={updateTabInURL}
      className={'mb-6'}
    >
      <TabList
        className={twJoin('border-b border-b-gray-300', 'flex gap-4', 'mb-8')}
      >
        {tabs.map((tab) => (
          <Tab
            key={tab.name}
            className={({ selected }) => tabStyle({ selected })}
            disabled={tab.disabled}
          >
            {tab.name}
          </Tab>
        ))}
      </TabList>
      <TabPanels>
        {tabs.map((tab) => (
          <TabPanel
            key={tab.name}
            tabIndex={-1}
            className={twJoin('outline-none')}
          >
            {tab.panel}
          </TabPanel>
        ))}
      </TabPanels>
    </TabGroup>
  );
};
